/* eslint-disable */
import * as React from "react";
import { WithStyles, withStyles } from "@material-ui/styles";
import { Box, Typography, Button } from "@material-ui/core";
import { FormattedMessage } from "react-intl";
import { isIE } from "react-device-detect";
import Footer from "../../../../layouts/Footer";
import Header from "../../../../layouts/Header";
import Layout from "../../../../layouts/Layout";
import { usePasswordAdd } from "../../shared/hooks/usePasswordAdd";
import { resetPasswordPageConfig } from "./constants/constants";
import messages from "./constants/messages";
import { styles } from "./constants/styles";
import { useLocation } from "react-router";
import { RequestStatus, useAuth, CheckLifeTimeTypeLinks } from "../../shared";
import { PasswordField } from "../../../../shared/ui/PasswordField";
import { useUserSettings } from "../../../user/components/UserSettings/useUserSettings";
import { useCheckLifeTimeLink } from "../../shared/hooks/useCheckLifeTimeLink";

type Props = WithStyles<typeof styles>;

const PasswordAddPage: React.FC<Props> = (props: Props) => {
  const [status, passwordAdd] = usePasswordAdd();
  const { setValidNewPass, changeField, validNewPass, state: stateForm, validPass, setValidPass } = useUserSettings();
  const [isAuth, , , logout] = useAuth();
  const [statusCheckLifeTime, checkLifeTimeLink] = useCheckLifeTimeLink();

  const useQuery = () => {
    return new URLSearchParams(useLocation().search);
  };

  const code = useQuery().get("code") || "";
  const userIdParam = useQuery().get("userId");
  const userId = userIdParam === null ? 0 : parseInt(userIdParam);

  const [queryParams] = React.useState<{
    userId: number;
    code: string;
  }>({
    userId,
    code,
  });

  React.useEffect(() => {
    const { userId } = queryParams;

    checkLifeTimeLink(userId, CheckLifeTimeTypeLinks.PasswordAdd);
  }, []);

  if (isAuth) {
    logout();
  }

  const handleApply = () => {
    const { newPassword } = stateForm;
    if (validNewPass && newPassword) {
      const { userId, code } = queryParams;
      passwordAdd(userId, code, newPassword);
    }
  };

  const handleKeyPress = (event: any) => {
    if (event.key === "Enter") {
      handleApply();
    }
  };

  const { classes } = props;
  const isPending = status === RequestStatus.Pending;
  const isStatusCheckLifeTimePending =
    statusCheckLifeTime === RequestStatus.Pending || statusCheckLifeTime === RequestStatus.None;

  if (isStatusCheckLifeTimePending) {
    return null;
  }

  return (
    <Layout>
      <Header />
      <div className={classes.root}>
        <Box className={classes.box}>
          <Typography className={classes.header}>
            <FormattedMessage {...messages.header} />
          </Typography>
          {resetPasswordPageConfig.map((item) => {
            return (
              <PasswordField
                variant="outlined"
                InputLabelProps={{
                  className: classes.inputLabel,
                  shrink: isIE? true : undefined
                }}
                className={classes.textField}
                value={stateForm[item.id as "newPassword" | "confirmPassword"]}
                onChange={({ target }) => changeField(item.id, target.value)}
                mode={item.id as any}
                onPasswordInvalid={
                  item.id === "confirmPassword" ? () => setValidNewPass(false) : () => setValidPass(false)
                }
                onPasswordValid={item.id === "confirmPassword" ? () => setValidNewPass(true) : () => setValidPass(true)}
                newPassword={(item.id === "confirmPassword" && stateForm["newPassword"]) || undefined}
                confirmPassword={(item.id === "newPassword" && stateForm["confirmPassword"]) || undefined}
                customLabel={(item.id === "newPassword" && messages.newPassword) || undefined}
                onKeyPress={handleKeyPress}
              />
            );
          })}
          <div className={classes.buttonBase}>
            <Button
              className={classes.changeButton}
              variant="contained"
              color="primary"
              onClick={handleApply}
              disabled={isPending || !validNewPass || !validPass}
            >
              <FormattedMessage {...messages.changeButton} />
            </Button>
          </div>
        </Box>
      </div>
      <Footer />
    </Layout>
  );
};

export default withStyles(styles)(PasswordAddPage);
